import type { SessionKind } from "../hooks/audit/useControlSessionEnvelope";
import { PermissionId } from "../models/permission";
import { WorkspaceMember } from "../models/workspace";

export const hasPermission = (
  member: WorkspaceMember | null | undefined,
  permission: PermissionId,
): boolean => member?.permissions?.includes(permission) ?? false;

export const hasAnyPermission = (
  member: WorkspaceMember | null | undefined,
  permissions: PermissionId[],
): boolean => permissions.some((p) => hasPermission(member, p));

export const canPerformWorkspaceWrites = (
  member: WorkspaceMember | null | undefined,
): boolean =>
  hasAnyPermission(member, [
    "run_test",
    "edit_test",
    "edit_control",
    "run_workstep_test",
    "edit_workstep_test",
    "edit_workstep",
  ]);

// A work step session is gated by the work-step sibling of the control
// session's run-test permission.
export const runTestPermissionFor = (sessionKind: SessionKind): PermissionId =>
  sessionKind === "work_step" ? "run_workstep_test" : "run_test";
